module.exports = __webpack_public_path__ + "media/images/article/caret-square-right-29e619f01502cef7e0cf5c22c1c9ee4c.svg";